import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const benefits = ['Sufres de ardor, hormigueo o dolor punzante en los pies, especialmente de noche.', 'Te han diagnosticado neuropatía diabética o pre-diabetes.', 'Tomas Metformina y no sabías que este medicamento agota tu vitamina B12.', 'Tienes miedo de perder la sensibilidad en tus pies y no darte cuenta de una herida.', 'Quieres un plan práctico y accionable, no solo depender de pastillas para el dolor.', 'Vives en USA y necesitas saber exactamente qué suplementos comprar y dónde.'];
export function BenefitsSection() {
  return <section className="py-20 lg:py-28 bg-cream" data-id="element-12">
      <div className="max-w-3xl mx-auto px-5 sm:px-8" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-lg overflow-hidden border border-emerald-brand/10" data-id="element-14">
          <div className="bg-emerald-brand py-7 px-8 text-center" data-id="element-15">
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-cream" data-id="element-16">
              Este Protocolo Es Para Ti Si...
            </h2>
          </div>
          <div className="p-7 sm:p-10" data-id="element-17">
            <ul className="space-y-5" data-id="element-18">
              {benefits.map((b, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -15
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.08
            }} className="flex items-start gap-4" data-id="element-19">
                  <div className="bg-emerald-light p-1.5 rounded-full flex-shrink-0 mt-1" data-id="element-20">
                    <CheckIcon className="w-5 h-5 text-emerald-brand" data-id="element-21" />
                  </div>
                  <span className="text-lg sm:text-xl font-body text-charcoal leading-relaxed" data-id="element-22">
                    {b}
                  </span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}